import { ModelBase } from '../shared/model.base';
import { ColumnTitle } from '../../decorators/shared/column-title.decorator';
import { ColumnType } from '../../decorators/shared/column-type.decorator';
import { TableColumns } from '../../decorators/shared/table-columns.decorator';
import { DataType } from '../../enums/shared/enums';
import { IdName } from '../shared/id-name.type';
import { Grupo } from '../groups/grupo.type';




@TableColumns
export class Sat extends ModelBase {

    execute_end_date: Date;
    execute_time: Date;
    message: string;
    recurrence_mode: string;

    status: IdName;
    groups: Array<Grupo>;


    @ColumnTitle('Nombre')
    name: string;

    @ColumnTitle('Tipo')
    type: string;

    @ColumnTitle('Fecha de Creacion')
    @ColumnType(DataType.date)
    create_date: Date;

    @ColumnTitle('Fecha de Ejecucion')
    @ColumnType(DataType.date)
    execute_date: Date;



    constructor() {
        super();

        this.name = '';
        this.type = '';
        this.create_date = null;
        this.execute_date = null;
    }
}
